import gql from "graphql-tag";

export const MY_HR_GET_IS_UNIQUE_EMAIL = gql`
  query isUniqueEmail($email: String!) {
    isUniqueEmail(email: $email)
  }
`;
